<template>
    <section id="features" class="py-20 bg-muted/30">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center max-w-3xl mx-auto mb-16">
                <div class="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full mb-4 uppercase text-sm tracking-wider font-medium">
                    {{ $t('features.badge') }}
                </div>
                <h2 class="text-3xl sm:text-4xl mb-4">
                    {{ $t('features.title') }}
                </h2>
                <p class="text-lg text-muted-foreground">
                    {{ $t('features.subtitle') }}
                </p>
            </div>

            <div class="grid md:grid-cols-3 gap-8">
                <div class="bg-white border border-border rounded-2xl p-8 hover:shadow-xl hover:border-foreground/10 transition-all">
                    <div class="size-14 bg-foreground text-white rounded-xl flex items-center justify-center mb-6">
                        <RocketLaunchIcon class="size-7" />
                    </div>
                    <h3 class="text-2xl mb-3">{{ $t('features.browse.title') }}</h3>
                    <p class="text-muted-foreground mb-6">
                        {{ $t('features.browse.description') }}
                    </p>
                </div>

                <div class="bg-white border border-border rounded-2xl p-8 hover:shadow-xl hover:border-foreground/10 transition-all">
                    <div class="size-14 bg-foreground text-white rounded-xl flex items-center justify-center mb-6">
                        <Cog6ToothIcon class="size-7" />
                    </div>
                    <h3 class="text-2xl mb-3">{{ $t('features.configure.title') }}</h3>
                    <p class="text-muted-foreground mb-6">
                        {{ $t('features.configure.description') }}
                    </p>
                </div>

                <div class="bg-white border border-border rounded-2xl p-8 hover:shadow-xl hover:border-foreground/10 transition-all">
                    <div class="size-14 bg-foreground text-white rounded-xl flex items-center justify-center mb-6">
                        <ArrowPathIcon class="size-7" />
                    </div>
                    <h3 class="text-2xl mb-3">{{ $t('features.activate.title') }}</h3>
                    <p class="text-muted-foreground mb-6">
                        {{ $t('features.activate.description') }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { RocketLaunchIcon, Cog6ToothIcon, ArrowPathIcon } from '@heroicons/vue/24/outline';

export default defineComponent({
    name: 'FeaturesSection',
    components: {
        RocketLaunchIcon,
        Cog6ToothIcon,
        ArrowPathIcon
    }
});
</script>
